import { render, staticRenderFns } from "./SysNoticeForm.vue?vue&type=template&id=1ca8aaa8&"
import script from "./SysNoticeForm.vue?vue&type=script&lang=js&"
export * from "./SysNoticeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports